"use strict";
//* Read more button
const readMoreBtn = document.querySelector(".read_more_btn");

readMoreBtn &&
  readMoreBtn.addEventListener("click", () => {
    const description = document.querySelector(
      ".description-container .description"
    );
 
    description.classList.toggle("active");

    description.classList.contains("active")
      ? (readMoreBtn.textContent = "read less")
      : (readMoreBtn.textContent = "read more");
  });

//* Tabbed component
const tabButtons = document.querySelectorAll(".tab-btn");

tabButtons &&
  tabButtons.forEach((btn) =>
    btn.addEventListener("click", (event) => {
      const showTab = event.target.getAttribute("data-id");
      const product = document.querySelector("#product");
      const productBtn = document.querySelector("[data-id='product']");
      const reviews = document.querySelector("#reviews");
      const reviewBtn = document.querySelector("[data-id='reviews']");

      if (showTab === "product") {
        product.classList.add("active");
        reviews.classList.remove("active");
        productBtn.classList.add("active");
        reviewBtn.classList.remove("active");
      }

      if (showTab === "reviews") {
        product.classList.remove("active");
        reviews.classList.add("active");
        productBtn.classList.remove("active");
        reviewBtn.classList.add("active");
      }
    })
  );

//* sliders
const swiper1 = new Swiper(".swiper1", {
  //* How much slide to scroll
  slidesPerGroup: 1,
  //* spacing between slides
  spaceBetween: 20,
  //* slide only according ro mouse scroll
  loop: true,
  speed: 1000,

  navigation: {
    nextEl: ".swiper-button-next-1",
    prevEl: ".swiper-button-prev-1",
  },

  //* Breakpoints
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

const swiper2 = new Swiper(".swiper2", {
  //* How much slide to scroll
  slidesPerGroup: 1,
  //* spacing between slides
  spaceBetween: 20,
  //* slide only according ro mouse scroll
  loop: true,
  speed: 1000,

  navigation: {
    nextEl: ".swiper-button-next-2",
    prevEl: ".swiper-button-prev-2",
  },

  //* Breakpoints
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

const swiper3 = new Swiper(".swiper3", {
  //* How much slide to scroll
  slidesPerGroup: 1,
  //* spacing between slides
  spaceBetween: 0,
  //* slide only according ro mouse scroll
  loop: true,
  speed: 1000,

  navigation: {
    nextEl: ".swiper-button-next-3",
    prevEl: ".swiper-button-prev-3",
  },

  //* Breakpoints
  breakpoints: {
    640: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 6,
    },
  },
});

const swiper4 = new Swiper(".swiper4", {
  //* How much slide to scroll
  slidesPerGroup: 1,
  //* spacing between slides
  spaceBetween: 0,
  //* slide only according ro mouse scroll
  speed: 1000,
  //* Slide to show
  slidesPerView: 2,

  navigation: {
    nextEl: ".swiper-button-next-4",
    prevEl: ".swiper-button-prev-4",
  },

  //* Breakpoints
  breakpoints: {
    375: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

$('fsb_close').on('click', function(e) {
  $('body').addClass('top_bar-hide');
  e.stopPropagation();
});

document.addEventListener("DOMContentLoaded", function () {
  let optionSelect = document.querySelector('#Option1'); 
  let variantSelect = document.querySelector('.product-form__variants'); 
  let addToCartBtn = document.querySelector('.product-form__cart-submit');

  if (optionSelect) {
    // get cart data from Liquid (static at page load)
    let cartData = JSON.parse(variantSelect.dataset.cart || "[]");

    function updateButton() {
      let selectedText = optionSelect.options[optionSelect.selectedIndex].text.trim();

      // find matching Shopify variant by text
      let matchingOption = Array.from(variantSelect.options).find(
        opt => opt.text.trim() === selectedText
      );

      if (matchingOption) {
        // sync hidden Shopify variant select
        variantSelect.value = matchingOption.value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

        // stock from variant
        let stockQty = parseInt(matchingOption.dataset.stock || "0", 10);

        // check if this variant already in cart
        let variantId = parseInt(matchingOption.value, 10);
        let cartItem = cartData.find(item => item.id === variantId);
        let alreadyInCartQty = cartItem ? cartItem.quantity : 0;
console.log(variantId);
console.log(stockQty);
        // remaining stock
        let remaining = stockQty - alreadyInCartQty;
console.log(remaining);
        // ✅ always toggle the button based on remaining stock
  if (cartItem && cartItem.id === variantId && remaining == 0) {
  console.log('wosfsfrk');
  addToCartBtn.setAttribute('disabled', 'disabled');
  addToCartBtn.classList.add('disabled');
} else {
  console.log('work');
  addToCartBtn.removeAttribute('disabled');
  addToCartBtn.classList.remove('disabled');
}
      }
    }

    // run on load + when custom dropdown changes
   updateButton();
    optionSelect.addEventListener('change', updateButton);
  }
});







